module.exports = __webpack_public_path__ + "img/کلاسیک 2.e351ddcc.jpg";